module.exports = __webpack_public_path__ + "img/icon-dashboard.78aab654.svg";